import React, { useState } from "react";
import InputAuth from "../../components/Auth/InputAuth/InputAuth";
import ButtonAuth from "../../components/Auth/ButtonAuth/ButtonAuth";
import { Link } from "react-router-dom";
import axios from "axios";

interface Props {}

const Register = (props: Props) => {
  const [errors, setErrors] = useState<string[]>([]);
  const [success, setSuccess] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmarPassword: "",
  });

  const onFormInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setErrors([]);
    setSuccess(null);

    try {
      await axios
        .post("http://localhost:5000/api/register", {
          email: formData.email,
          password: formData.password,
          confirmarPassword: formData.confirmarPassword,
        })
        .then(() => {
          setSuccess("Registado com sucesso!");
          setFormData({ email: "", password: "", confirmarPassword: "" });
        });
    } catch (err: any) {
      if (err.response && err.response.data.errors) {
        setErrors(err.response.data.errors[0].msg);
      } else {
        setErrors(["An unexpected error occurred. Please try again."]);
      }
    }
  };

  return (
    <div className="flex w-full h-90vh justify-center items-center animate-slideTopSm">
      <div className="flex rounded-xl py-8 px-8 gap-4 flex-col w-full sm:w-3/4 md:w-1/2 lg:w-1/4 min-w-80 h-fit drop-shadow-lg bg-main-white">
        <h1 className="mb-4 self-center text-2xl font-semibold text-main-black font-inter">
          Registo
        </h1>
        <form onSubmit={onSubmit} className="flex flex-col gap-4">
          <InputAuth
            onChange={onFormInputChange}
            value={formData.email}
            name="email"
            text="Email"
            type="text"
          />
          <InputAuth
            onChange={onFormInputChange}
            value={formData.password}
            name="password"
            text="Password"
            type="password"
          />
          <InputAuth
            onChange={onFormInputChange}
            value={formData.confirmarPassword}
            name="confirmarPassword"
            text="Confirmar Password"
            type="password"
          />
          <ButtonAuth type="submit" text="Registar" backgroundFilled={true} />
        </form>
        {success && (
          <p className="font-inter text-green-success self-center">{success}</p>
        )}
        {errors.length > 0 && (
          <p className="font-inter text-red-error self-center">{errors}</p>
        )}
        <hr className="my-3 fill-light-black" />
        <p className="self-center">Já está registado?</p>
        <Link to="/login" className="w-full">
          <ButtonAuth text="Login" backgroundFilled={false} />
        </Link>
      </div>
    </div>
  );
};

export default Register;
